import React, { useState } from "react";
import { Box, Typography, Divider, TextField, InputAdornment, FormControl, Select, MenuItem, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import Switch from "react-switch";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import dayjs from 'dayjs';

const forecastOptions = Array.from({ length: 7 }, (_, index) => ({
  value: index + 1,
  label: dayjs().add(index, 'day').format('YYYY-MM-DD (07:00)'),
}));

const useStyles = makeStyles({
    dayList: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: 8,
        marginTop: 8,
        overflow: 'hidden',
    },
    dayItem: {
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        flex: '1 1 0',
        minWidth: 0,
        height: 44,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        outline: 'none',
    },
    dayItemActive: {
        backgroundColor: '#168BDE',
        boxShadow: '0px 6px 14px rgba(22, 139, 222, 0.24)',
    },
    dayLabel: {
        fontFamily: 'Kanit',
        fontWeight: 600,
        fontSize: 12,
        lineHeight: '14px',
        color: '#7A8B9C',
    },
    dayDate: {
        fontFamily: 'Kanit',
        fontWeight: 400,
        fontSize: 11,
        lineHeight: '16px',
        color: '#98A6B5',
    },
    dayLabelActive: {
        color: '#FFFFFF',
    },
    dayDateActive: {
        color: '#FFFFFF',
        fontSize: 10,
        lineHeight: '12px',
    },
    statusList: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 16,
    },
    statusItem: {
        height: 29,
        padding: '0 14px',
        borderRadius: 999,
        border: '1px solid #D8DEE4',
        backgroundColor: '#FFFFFF',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        fontFamily: 'Kanit',
        fontWeight: 400,
        fontSize: 10,
        color: '#66788A',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
    },
    statusItemActive: {
        border: '1px solid #8CCBFF',
        backgroundColor: '#EAF6FF',
        color: '#0672C8',
        fontWeight: 500,
    },
    statusDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
    },
    statusDotWarning: {
        backgroundColor: '#F04438',
    },
    statusDotWatch: {
        backgroundColor: '#FDB022',
    },
    fullBleedDivider: {
        marginLeft: -16,
        marginRight: -16,
        backgroundColor: '#DBE5EC',
        height: 1,
    },
});

const dayItems = [
    { label: 'วันนี้', date: '14 ก.ค.' },
    { label: 'พ.', date: '15 ก.ค.' },
    { label: 'พฤ.', date: '16 ก.ค.' },
    { label: 'ศ.', date: '17 ก.ค.' },
    { label: 'ส.', date: '18 ก.ค.' },
    { label: 'อา.', date: '19 ก.ค.' },
    { label: 'จ.', date: '20 ก.ค.' },
];

export default function RRISidebar({ 
    sidebarOpen, 
    setSidebarOpen, 
    mainRiver, 
    setMainRiver, 
    basin, 
    setBasin,
    waterLevel, 
    setWaterLevel,
    rainfallEnabled,
    setRainfallEnabled,
    forecastDay,
    setForecastDay,
    largeDamEnabled,
    setLargeDamEnabled,
    setMediumDamEnabled,
    rriStationEnabled,
    setRriStationEnabled,
    rriReservoirEnabled,
    setRriReservoirEnabled,
    rriStations,
    onStationSelect,
    rriTifEnabled,
    setRriTifEnabled,
    rriLatestQr = {},
    rriThresholds = {},
    onStatusChange,
}) 
{
        const classes = useStyles();

    const { t } = useTranslation();
    const [enabled, setEnabled] = useState(false);
    const [mockSwitch, setMockSwitch] = useState(false);
    const [subRiver, setSubRiver] = useState(false);
    const [openRiver, setOpenRiver] = useState(false);
    const [secoundRiver, setsecoundRiver] = useState(false);
    const [provinceBoundary, setProvinceBoundary] = useState(false);
    const [amphoeBoundary, setAmphoeBoundary] = useState(false);
    const [openBoundary, setOpenBoundary] = useState(false);
    const [tambonBoundary, setTambonBoundary] = useState(false);
    const [mockSwitch1, setMockSwitch1] = useState(false);
    const [search, setSearch] = useState('');
    const [activeDayIndex, setActiveDayIndex] = useState(0);
    const [activeStatusIndex, setActiveStatusIndex] = useState(0);
    const [stationCount, setStationCount] = React.useState(0);


    const { alarmCount, criticalCount } = React.useMemo(() => {
        let alarm = 0, critical = 0;
        (rriStations ?? []).forEach(f => {
            const name = f.properties?.station || f.properties?.reservoir;
            const qr = rriLatestQr[name];
            const th = rriThresholds[name];
            if (qr == null || !th) return;
            if (th.critical != null && qr >= th.critical) critical++;
            else if (th.alarm != null && qr >= th.alarm)  alarm++;
        });
        return { alarmCount: alarm, criticalCount: critical };
    }, [rriStations, rriLatestQr, rriThresholds]);

    const statusItems = React.useMemo(() => [
        { label: `ทั้งหมด ${stationCount}` },
        { label: `เตือนภัย ${alarmCount}`,   dotClass: 'warning' },
        { label: `เฝ้าระวัง ${criticalCount}`, dotClass: 'watch' },
    ], [stationCount, alarmCount, criticalCount]);

    const filteredStations = search.trim().length === 0 ? [] : (rriStations ?? [])
    .filter(f => {
        const { station, province, amphoe, tambon } = f.properties;
        if (!station) return false;
        const q = search.trim().toLowerCase();
        return (
        station?.toLowerCase().includes(q) ||
        province?.includes(search.trim()) ||
        amphoe?.includes(search.trim()) ||
        tambon?.includes(search.trim())
        );
    });

    React.useEffect(() => {
    fetch(`${process.env.REACT_APP_LIVE_HII}/product/latest/rri/metadata/json/rri_station_final.geojson`)
        .then(res => res.json())
        .then(data => {
        const count = data.features.filter(f => f.properties.station).length;
        setStationCount(count);
        })
        .catch(() => {});
    }, []);

  return (
    <div style={{
        width: sidebarOpen ? 356 : 0,
        minWidth: sidebarOpen ? 356 : 0,
        height: '100%',
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
        border: sidebarOpen ? '1px solid #BBCEDAE5' : 'none',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.25s ease, min-width 0.25s ease',
    }}>
    <Box p={2} style={{ overflowY: 'auto', height: '100%' }}>
            {/* <Box mb={2}>
                <Typography
                    variant="h6"
                    style={{
                        fontFamily: 'Kanit',
                        fontWeight: 400,
                        color: '#7890A3',
                        fontSize: '15px',
                        lineHeight: 1.2,
                    }}
                >
                    ช่วงเวลาคาดการณ์
                </Typography>

                <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginTop: 2 }}>
                    <Typography
                        variant="h6"
                        style={{
                            fontFamily: 'Kanit',
                            fontWeight: 600,
                            fontSize: '20px',
                            lineHeight: 1.2,
                        }}
                    >
                        เลือกวันแสดงผล
                    </Typography>

                    <Typography
                        style={{
                            fontFamily: 'Kanit',
                            fontWeight: 600,
                            fontSize: '15px',
                            color: '#0A7ED8',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        วันที่ {activeDayIndex + 1}/6
                    </Typography>
                </Box>

                <Box className={classes.dayList}>
                    {dayItems.map((item, index) => {
                      const isActive = index === activeDayIndex;

                      return (
                        <Box
                          key={`${item.label}-${item.date}`}
                          component="button"
                          type="button"
                          onClick={() => setActiveDayIndex(index)}
                          className={`${classes.dayItem} ${isActive ? classes.dayItemActive : ''}`}
                        >
                          <Typography className={`${classes.dayLabel} ${isActive ? classes.dayLabelActive : ''}`}>
                            {item.label}
                          </Typography>
                          <Typography className={`${classes.dayDate} ${isActive ? classes.dayDateActive : ''}`}>
                            {item.date}
                          </Typography>
                        </Box>
                      );
                    })}
                </Box>
            </Box>

            <Divider
                className={classes.fullBleedDivider}
                style={{
                    marginTop: 20,
                    marginBottom: 20,
                }}
            /> */}
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            mb={1}
            >
            <Box>
                <Typography
                style={{
                    fontFamily: 'Kanit',
                    fontWeight: 400,
                    color: '#7890A3',
                    fontSize: 10,
                }}
                >
                {t('ค้นหาพื้นที่')}
                </Typography>

                <Typography
                style={{
                    fontFamily: 'Kanit',
                    fontWeight: 700,
                    fontSize: 15,
                    lineHeight: '24px',
                }}
                >
                {t('สถานีคาดการณ์น้ำท่า')}
                </Typography>
            </Box>

            <Button
                onClick={() => setSidebarOpen(false)}
                style={{
                minWidth: 36,
                width: 36,
                height: 36,
                padding: 6,
                borderRadius: 8,
                border: '1px solid #CCCCCC',
                background: '#F7F7F7D9',
                }}
            >
                <ChevronLeftIcon style={{ fontSize: 20, color: '#000000' }} />
            </Button>
            </Box>
            <TextField
                fullWidth
                variant="outlined"
                placeholder="ตำบล อำเภอ จังหวัด"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                    <SearchIcon                   
                    style={{
                        color: '#9CA3AF',
                        transform: 'scaleX(-1)',
                        fontSize: 14,
                    }} 
                  />
                    </InputAdornment>
                ),
                style: {
                    borderRadius: 9,
                    backgroundColor: '#FFFFFF',
                    fontFamily: 'Kanit',
                    height: 40,
                    },
                }}
            />

            {filteredStations.length > 0 && (
            <Box
                style={{
                border: '1px solid #DBE5EC',
                borderRadius: 8,
                marginTop: 4,
                maxHeight: 200,
                overflowY: 'auto',
                backgroundColor: '#fff',
                }}
            >
                {filteredStations.map((f, i) => {
                const { station, province, amphoe, tambon, lat, lon } = f.properties;
                return (
                    <Box
                    key={i}
                    px={2}
                    py={1}
                    style={{ cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                    onClick={() => {
                        if (onStationSelect && lat && lon) {
                        onStationSelect(parseFloat(lat), parseFloat(lon));
                        }
                        setSearch('');
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                    <Typography style={{ fontFamily: 'Kanit', fontSize: 12, fontWeight: 500 }}>
                        {`สถานี ${station}`}
                    </Typography>
                    <Typography style={{ fontFamily: 'Kanit', fontSize: 10, color: '#6B7280' }}>
                        {`ต.${tambon ?? ''} อ.${amphoe ?? ''} จ.${province ?? ''}`}
                    </Typography>
                    </Box>
                );
                })}
            </Box>
            )}

            <Box mt={2} className={classes.statusList}>
                {statusItems.map((item, index) => {
                    const isActive = index === activeStatusIndex;

                    return (
                        <Box
                            key={item.label}
                            component="button"
                            type="button"
                            onClick={() => {
                                setActiveStatusIndex(index);
                                if (onStatusChange) onStatusChange(index);
                            }}
                            className={`${classes.statusItem} ${isActive ? classes.statusItemActive : ''}`}
                        >
                            {item.dotClass === 'warning' && (
                                <Box className={`${classes.statusDot} ${classes.statusDotWarning}`} />
                            )}
                            {item.dotClass === 'watch' && (
                                <Box className={`${classes.statusDot} ${classes.statusDotWatch}`} />
                            )}
                            {item.label}
                        </Box>
                    );
                })}
            </Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
            >
                {/* Left */}
                <Box>
                <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                >
                    สถานีระดับน้ำท่า
                </Typography>

                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                >
                    สถานีตรวจวัด
                </Typography>
                </Box>

                {/* Right */}
                <Switch
                    checked={rriStationEnabled}
                    onChange={setRriStationEnabled}
                    height={19}
                    width={34}
                    handleDiameter={13}
                    onColor="#2196F3"
                    offColor="#D9D9D9"
                    checkedIcon={false}
                    uncheckedIcon={false}
                />
            </Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
            >
                {/* Left */}
                <Box>
                <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                >
                    สถานีเขื่อน
                </Typography>

                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                >
                    สถานีตรวจวัด
                </Typography>
                </Box>

                {/* Right */}
                <Switch
                    checked={rriReservoirEnabled}
                    onChange={setRriReservoirEnabled}
                    height={19}
                    width={34}
                    handleDiameter={13}
                    onColor="#2196F3"
                    offColor="#D9D9D9"
                    checkedIcon={false}
                    uncheckedIcon={false}
                />
            </Box>

            <Divider
                className={classes.fullBleedDivider}
                style={{
                    marginTop: 20,
                    marginBottom: 20,
                }}
            />

            <Typography
                variant="h6"
                style={{ fontFamily: 'Kanit', fontWeight: 400, color: '#7890A3', fontSize: '13px', marginTop: '10px'  }}
            >
                {t('ชั้นข้อมูล')}
            </Typography>
            <Typography
                variant="h6"
                style={{ fontFamily: 'Kanit', fontWeight: 700, marginBottom: 10, fontSize: '15px'  }}
            >
                {t('การแสดงผลบนแผนที่')}
            </Typography>

            <Box>
                {/* <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                    <Box>
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                    >
                        สถานีระดับน้ำ
                    </Typography>

                    <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                    >
                        สถานีตรวจวัด
                    </Typography>
                    </Box>

                    <Switch
                        checked={waterLevel}
                        onChange={setWaterLevel}
                        height={19}
                        width={34}
                        handleDiameter={13}
                        onColor="#2196F3"
                        offColor="#D9D9D9"
                        checkedIcon={false}
                        uncheckedIcon={false}
                    />
                </Box> */}

                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                <Box>
                    <Typography style={{ fontFamily: 'Kanit', fontWeight: 500, fontSize: 12 }}>ฝนตรวจวัด</Typography>
                    <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#6B7280' }}>สถานีตรวจวัด</Typography>
                </Box>
                <Switch
                    checked={rainfallEnabled}
                    onChange={(checked) => setRainfallEnabled(checked)}
                    height={19} width={34} handleDiameter={13}
                    onColor="#2196F3" offColor="#D9D9D9"
                    checkedIcon={false} uncheckedIcon={false}
                />
                </Box>
                {rainfallEnabled && (
                <Box mt={1}>
                    <FormControl fullWidth variant="outlined" size="small">
                    <Select
                        value={forecastDay}
                        onChange={(e) => setForecastDay(e.target.value)}
                        style={{ height: 36, fontFamily: 'Kanit', fontSize: 14, borderRadius: 6 }}
                    >
                        <MenuItem value={1}>วานนี้</MenuItem>
                        <MenuItem value={2}>วันนี้</MenuItem>
                        <MenuItem value={3}>24 ชั่วโมง</MenuItem>
                        <MenuItem value={4}>3 วัน</MenuItem>
                        <MenuItem value={5}>7 วัน</MenuItem>
                        <MenuItem value={6}>15 วัน</MenuItem>
                        <MenuItem value={7}>30 วัน</MenuItem>
                    </Select>
                    </FormControl>
                </Box>
                )}

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={2}
                >
                    {/* Left */}
                    <Box>
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                    >
                        อ่างขนาดใหญ่-กลาง
                    </Typography>

                    <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                    >
                        สถานีตรวจวัด
                    </Typography>
                    </Box>

                    {/* Right */}
                    <Switch
                        checked={largeDamEnabled}
                        onChange={(checked) => {
                            setLargeDamEnabled(checked);
                            setMediumDamEnabled(checked);
                        }}
                        height={19}
                        width={34}
                        handleDiameter={13}
                        onColor="#2196F3"
                        offColor="#D9D9D9"
                        checkedIcon={false}
                        uncheckedIcon={false}
                    />
                </Box>

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={2}
                >
                    {/* Left */}
                    <Box>
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                    >
                        ปริมาณการไหลเชิงพื้นที่
                    </Typography>

                    <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                    >
                        ล่วงหน้า 1–6 วัน
                    </Typography>
                    </Box>

                    {/* Right */}
                    <Switch
                        checked={rriTifEnabled}
                        onChange={setRriTifEnabled}
                        height={19}
                        width={34}
                        handleDiameter={13}
                        onColor="#2196F3"
                        offColor="#D9D9D9"
                        checkedIcon={false}
                        uncheckedIcon={false}
                    />
                </Box>
                {rriTifEnabled && (
                <Box mt={1}>
                    <FormControl fullWidth variant="outlined" size="small">
                    <Select
                        value={forecastDay}
                        onChange={(e) => setForecastDay(e.target.value)}
                        style={{ height: 36, fontFamily: 'Kanit', fontSize: 14, borderRadius: 6 }}
                    >
                        {forecastOptions.map((item) => (
                        <MenuItem key={item.value} value={item.value} style={{ fontFamily: 'Kanit', fontSize: 14 }}>
                            {item.label}
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </Box>
                )}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={2}
                >
                    {/* Left */}
                    <Box>
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                    >
                        ขอบเขตลุ่มน้ำ
                    </Typography>

                    <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                    >
                        22 ลุ่มน้ำหลัก
                    </Typography>
                    </Box>

                    {/* Right */}
                    <Switch
                        checked={basin}
                        onChange={setBasin}
                        height={19}
                        width={34}
                        handleDiameter={13}
                        onColor="#2196F3"
                        offColor="#D9D9D9"
                        checkedIcon={false}
                        uncheckedIcon={false}
                    />
                </Box>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={2}
                >
                    {/* Left */}
                    <Box>
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                    >
                        เส้นแม่น้ำ
                    </Typography>

                    <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                    >
                        โครงข่ายลำน้ำ
                    </Typography>
                    </Box>

                    {/* Right */}
                    <Switch
                        checked={mainRiver}
                        onChange={setMainRiver}
                        height={19}
                        width={34}
                        handleDiameter={13}
                        onColor="#2196F3"
                        offColor="#D9D9D9"
                        checkedIcon={false}
                        uncheckedIcon={false}
                    />
                </Box>
            </Box>

    </Box>
    </div>
  );
}